import React from "react";

export const CollapseIcon = ({nameOfClass, setIsCollapsed}) => {
    return <svg className={nameOfClass} onClick={() => setIsCollapsed? setIsCollapsed(prev=>!prev):''} width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 1L1 5L5 9" stroke="#B6B6B6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>;
};